"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Slide = void 0;
var _styled = _interopRequireDefault(require("@emotion/styled"));
var _withFocusClassName = require("../../../util/withFocusClassName");
var _toggleTheme = require("./toggleTheme");
const Slide = (0, _withFocusClassName.withFocusToggleClassName)((0, _styled.default)("div")`
    background-color: ${_toggleTheme.getBackgroundColor};
    border: ${_toggleTheme.getBorder};
    border-radius: ${_ref => {
  let {
    size,
    themeMode
  } = _ref;
  return _toggleTheme.toggleTheme.height[size](themeMode);
}};
    height: ${_ref2 => {
  let {
    size,
    themeMode
  } = _ref2;
  return _toggleTheme.toggleTheme.height[size](themeMode);
}};
    width: ${_ref3 => {
  let {
    size,
    themeMode
  } = _ref3;
  return _toggleTheme.toggleTheme.width[size](themeMode);
}};
    box-sizing: border-box;
    cursor: ${props => props.isDisabled ? "not-allowed" : "pointer"};
    display: flex;
    flex-shrink: 0;
    justify-content: space-between;
    align-items: center;

    &:active span {
        ${_ref4 => {
  let {
    size,
    themeMode,
    isChecked,
    isDisabled
  } = _ref4;
  return themeMode.includes("ursa") && !isDisabled && `
            width: ${_toggleTheme.toggleTheme.handleSize[size](themeMode) + 4}px;
            border-radius: ${_toggleTheme.toggleTheme.height[size](themeMode)};
            margin-left: ${_toggleTheme.toggleTheme.handleMargin[size](themeMode) - (isChecked ? 4 : 0)}px;
        `;
}}
    }

    transition: ${_ref5 => {
  let {
    themeMode
  } = _ref5;
  return _toggleTheme.toggleTheme.motion.default(themeMode);
}};

    // Needed for the outline component.
    position: relative;

    ${_toggleTheme.getSlideHoverStyles};

    ${_ref6 => {
  let {
    isFocused,
    size,
    themeMode
  } = _ref6;
  return isFocused && (0, _toggleTheme.getFocusRingStyles)({
    size,
    themeMode
  });
}};
`);
exports.Slide = Slide;
Slide.displayName = "Slide";
//# sourceMappingURL=Slide.js.map